module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.remove),
      expression: "showPopup.remove"
    }],
    staticClass: "sweet-alert showSweetAlert visible",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_c('div', {
    staticClass: "sa-icon sa-info",
    staticStyle: {
      "display": "block"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.quizToRemove) ? _c('p', {
    staticClass: "lead text-muted text-left"
  }, [_vm._v("\n      Etes-vous sûr de vouloir supprimer le questionnaire « " + _vm._s(_vm.quizToRemove.title) + " » ?\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('button', {
    staticClass: "cancel btn btn-lg btn-default btn-danger",
    on: {
      "click": function($event) {
        _vm.showPopup.remove = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.removeQuiz()
      }
    }
  }, [_vm._v("Oui")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.duplicate),
      expression: "showPopup.duplicate"
    }],
    staticClass: "sweet-alert showSweetAlert visible",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_c('div', {
    staticClass: "sa-icon sa-info",
    staticStyle: {
      "display": "block"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Formulaire de duplication")]), _vm._v(" "), (_vm.quizToDuplicate) ? _c('p', {
    staticClass: "lead text-muted text-left"
  }, [_vm._v("\n      Vous êtes sur le point de dupliquer le questionnaire « " + _vm._s(_vm.quizToDuplicate.title) + " »."), _c('br'), _c('br'), _vm._v("\n      Veuillez choisir le titre de la copie de ce questionnaire, "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("attention le titre ne pourra pas être changé après la duplication")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input",
    staticStyle: {
      "display": "block"
    }
  }, [_c('form', {
    staticClass: "absolute-parlsey-errors",
    attrs: {
      "id": "formDuplicate"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTitle),
      expression: "newTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nouveau titre",
      "required": ""
    },
    domProps: {
      "value": (_vm.newTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('button', {
    staticClass: "cancel btn btn-lg btn-default btn-danger",
    on: {
      "click": function($event) {
        _vm.showPopup.duplicate = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.duplicateQuiz()
      }
    }
  }, [_vm._v("Valider")])])])]), _vm._v(" "), _c('section', {
    staticClass: "tile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile-body mb-50"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet,
      "order": [1, 'asc']
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-circle green mt-20",
    attrs: {
      "to": {
        name: 'quizzes_create'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n             Nouveau questionnaire\n          ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile-header dvd dvd-btm tabbable-line"
  }, [_c('h1', [_vm._v("Liste des questionnaires")]), _c('br'), _vm._v(" "), _c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-255b3d34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quizzes/list.vue
// module id = 109
// module chunks = 0